import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { LicenceTypeDto } from 'src/app/dtos/dtos';
import { LicenceTypeService } from 'src/app/services/licenceType.service';

@Component({
  selector: 'je-licence-types',
  templateUrl: './licence-types.component.html',
  styleUrls: ['./licence-types.component.scss']
})
export class LicenceTypesComponent implements OnInit {

  subs: Subscription[] = [];
  licenceTypes: LicenceTypeDto[];

  displayedColumns: string[] = [
    'id',
    'description',
    'priceHuf',
    'priceEur'];

  constructor(public licenceTypeService: LicenceTypeService) {
  }

  ngOnInit() {
    this.subs.push(this.licenceTypeService.getAll().subscribe(resp => this.licenceTypes = resp));
  }

  ngOnDestroy(): void {
    this.subs.forEach(e => e.unsubscribe());
  }
}
